// useElementSize.js
import { useState, useEffect } from "react";

const useElementSize = (ref) => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref.current) return;

    const element = ref.current;
    let isMounted = true;
    let frameId = null;

    const updateSize = () => {
      const { width, height } = element.getBoundingClientRect();

      // Esperar al siguiente frame para evitar conflicto del ResizeObserver
      if (frameId) {
        cancelAnimationFrame(frameId);
      }

      frameId = requestAnimationFrame(() => {
        if (!isMounted) return;
        setSize(prev => {
          if (prev.width !== width || prev.height !== height) {
            return { width, height };
          }
          return prev;
        });
      });
    };

    updateSize();

    const observer = new ResizeObserver(updateSize);
    observer.observe(element);

    return () => {
      isMounted = false;
      if (frameId) {
        cancelAnimationFrame(frameId);
      }
      observer.disconnect();
    };
  }, [ref]);

  return size;
};

export default useElementSize;
